'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'traffic-light-stop';
var width = 320;
var height = 512;
var aliases = [];
var unicode = 'f63a';
var svgPathData = ['M48 32l0 352c0 61.9 50.1 112 112 112s112-50.1 112-112l0-352c0-8.8-7.2-16-16-16L64 16c-8.8 0-16 7.2-16 16zm168 80a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm0 144a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM104 400c0-30.9 25.1-56 56-56s56 25.1 56 56-25.1 56-56 56-56-25.1-56-56z', 'M64 16c-8.8 0-16 7.2-16 16l0 352c0 61.9 50.1 112 112 112s112-50.1 112-112l0-352c0-8.8-7.2-16-16-16L64 16zM0 32C0-3.3 28.7-32 64-32l192 0c35.3 0 64 28.7 64 64l0 352c0 88.4-71.6 160-160 160S0 472.4 0 384L0 32zM160 344c30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56 25.1-56 56-56zm56-88a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm-56-88a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm24 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM160 424c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTrafficLightStop = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;